import React from 'react'

function RemoveBgEditorLayout({children}) {
    return <div className="RemoveBgEditor">{children}</div>
}

export default RemoveBgEditorLayout
